// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"Header_mainHeading__1SIdm","text":"Header_text__1g8lz","textFirst":"Header_textFirst__1Lzkp"};